var React = require('react');

function UmbrellaInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","stroke":"#004c97","strokeWidth":"3","strokeLinecap":"round","strokeLinejoin":"round"},[React.createElement("path",{"d":"M39.5 3V1.5M77.5 42.5c0-4.8-5.7-8.6-12.7-8.6s-12.7 3.9-12.7 8.6c0-4.8-5.7-8.6-12.7-8.6s-12.7 3.9-12.7 8.6c0-4.8-5.7-8.6-12.7-8.6S1.5 37.8 1.5 42.5","key":0}),React.createElement("path",{"d":"M77.5 42.5c0-21-17-38-38-38s-38 17-38 38","key":1}),React.createElement("path",{"d":"M39.5 34.9v34.2c0 4.6-3.7 8.4-8.4 8.4s-8.4-3.7-8.4-8.4","key":2})]));
}

UmbrellaInline.defaultProps = {"width":"44","height":"44","viewBox":"0 0 79 79"};

module.exports = UmbrellaInline;

UmbrellaInline.default = UmbrellaInline;
